import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const exerciseImages: Record<string, string> = import.meta.glob('@/assets/landing/exercise/*.webp', {
	eager: true,
	import: 'default',
})

const schema: LandingScreenSchema = {
	config: {
		background: 'accent',
		funnelFeatureFlag: 'creatives_exercise',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_funnel.pages.landing.title_personalized_workout_plan'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			title: $t('female_funnel.pages.landing.subtitle_personalized_workout_plan'),
			uppercase: true,
		}),

		LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => {
			const img =
				Object.entries(exerciseImages).find(([k]) => k.includes(`${ctx.language}.webp`))?.[1] ??
				Object.entries(exerciseImages).find(([k]) => k.includes('en.webp'))?.[1]

			return {
				img,
				customStyles: {
					height: '40vh',
					marginTop: 'var(--size-24)',
					marginBottom: 'var(--size-24)',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
